/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  IFullProvenanceMethods,
  FullProvenanceService,
  ITOSProductMethods,
  TOSProductService,
  IFeedbackFormMethods,
  FeedbackFormService
} from "./components";

export type FullProvenancePageAgent = IStaticPageContentMethods &
  IFullProvenanceMethods &
  ITOSProductMethods &
  IFeedbackFormMethods 

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new FullProvenanceService(),
    new TOSProductService(),
    new FeedbackFormService()
  ];
};

export const getAgent = () => {
  return createAgent<FullProvenancePageAgent>({
    plugins: getPlugins(),
  });
};
